<template>
  <Main>
    <BaseTab
      class="endorsement-list__tab px-0 mx-0"
      :value="currentTab"
      @change="currentTab = $event"
    >
      <v-row>
        <v-col cols="auto" class="endorsement-list__col">
          <v-tab>ENDOSSOS</v-tab>
        </v-col>
        <v-col cols="auto" class="endorsement-list__col">
          <v-tab>SOLICITAÇÕES DE ENDOSSOS</v-tab>
        </v-col>
        <v-spacer class="d-none d-md-flex" />
        <v-col
          cols="12"
          md="3"
          xl="2"
          class="pb-md-0 pl-sm-5 d-none d-md-flex"
          v-if="canRequestEndorsement"
        >
          <BaseButton
            width="100%"
            outlined
            color="secondary"
            v-html="'SOLICITAR ENDOSSO'"
            @click="redirectNewRequestEndorsement"
          />
        </v-col>
        <v-col
          cols="12"
          md="3"
          xl="2"
          class="pl-sm-5 pb-md-0 d-none d-md-flex"
          v-if="canCreateEndorsement"
        >
          <BaseButton
            class="secondary white--text justify-start"
            width="100%"
            @click="redirectNewEndorsement"
          >
            <v-icon class="pr-0 pr-md-9 pr-xl-3">
              fa-plus
            </v-icon>
            NOVO ENDOSSO
          </BaseButton>
        </v-col>
      </v-row>
      <v-tab-item class="pt-5">
        <HeaderEndorsementList />
        <EndorsementTable />
      </v-tab-item>
      <v-tab-item class="pt-5">
        <HeaderEndorsementList />
        <RequestEndorsementTable />
      </v-tab-item>
    </BaseTab>
  </Main>
</template>
<script>
import EndorsementTable from "../components/EndorsementTable";
import RequestEndorsementTable from "../components/RequestEndorsementTable";
import HeaderEndorsementList from "../components/HeaderEndorsementList";
import { mapState } from "vuex";
export default {
  name: "EndorsementList",
  data: () => ({
    currentTab: 0
  }),
  components: {
    EndorsementTable,
    RequestEndorsementTable,
    HeaderEndorsementList
  },
  computed: {
    ...mapState(["userPermissions"]),
    firstTab() {
      return this.currentTab == 0;
    },
    canRequestEndorsement() {
      return this.userPermissions.acoes.some(x => x.id == "solicitar_endosso");
    },
    canCreateEndorsement() {
      return this.userPermissions.acoes.some(x => x.id == "criar_endosso");
    }
  },
  mounted() {
    this.currentTab = this.$route.params.currentTab ?? 0;
  },
  methods: {
    redirectNewRequestEndorsement() {
      this.$router.push({
        name: "new request endorsement request",
        params: { id: "." }
      });
    },
    redirectNewEndorsement() {
      this.$router.push({
        name: "new request endorsement",
        params: { id: "." }
      });
    }
  }
};
</script>
<style lang="sass">
.endorsement-list__
  &col
    align-self: center
  &tab
    .v-tabs-bar
      height: 50px !important
</style>
